import { Box, Typography, ButtonBase, Tooltip } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { EVENT_LABELS } from '@tymely/features/Ticket/constants';
import { useIntentsQuery } from '@tymely/services';
import { useMemo } from 'react';

import CommentIdWithTooltip from './CommentIdWithTooltip';
import { PreFilterHeaderProps } from '../types';
import { ExpandIconBox } from '../../styled';

const PreFilterHeader = ({ kind, eventData, expanded, onToggle, commentId }: PreFilterHeaderProps) => {
    const intents = useIntentsQuery();
    const inferredIntentValue = useMemo(() => {
        const match = eventData.decision.condition_lineage.find(
            (cond: string) => cond.includes('Inferred intent by scored embedding') && /\(value is .*?\)/.test(cond),
        );
        if (!match) return undefined;
        const valueMatch = match.match(/\(value is (.*?)\)/);
        return valueMatch ? valueMatch[1] : undefined;
    }, [kind, eventData?.decision?.condition_lineage]);

    let intentName: string | undefined = undefined;
    if (inferredIntentValue && intents && intents.data) {
        const found = intents.data.find((intent) => String(intent.id) === String(inferredIntentValue));
        intentName = found?.name;
    }
    return (
        <ButtonBase
            onClick={onToggle}
            sx={{ width: '100%', textAlign: 'left', display: 'block', p: 0, borderRadius: 1 }}
            disableRipple
        >
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Typography color="error.dark" variant="body2" component="span" sx={{ fontWeight: 'normal' }}>
                    <b>{eventData.decision?.title}</b>
                </Typography>
                <Typography variant="subtitle2" fontWeight="bold" sx={{ display: 'inline', ml: 1 }}>
                    {EVENT_LABELS[kind]}
                </Typography>
                {inferredIntentValue && eventData.decision?.title !== 'No decision' && (
                    <Tooltip title={intentName ? intentName : 'Unknown Intent'}>
                        <Typography
                            variant="body2"
                            color="error.dark"
                            component="span"
                            sx={{ fontWeight: 'normal', ml: 1, cursor: 'pointer' }}
                        >
                            : <b>{inferredIntentValue}</b>
                        </Typography>
                    </Tooltip>
                )}
                {commentId && <CommentIdWithTooltip commentId={commentId} />}
                {eventData.decision?.condition_lineage && (
                    <ExpandIconBox>{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ExpandIconBox>
                )}
            </Box>
        </ButtonBase>
    );
};

export default PreFilterHeader;
